import { useStore } from '@tanstack/react-store';
import { AuditDetailModal } from '../components/audit/AuditDetailModal';
import { AuditFilterBar } from '../components/audit/AuditFilterBar';
import { AuditTable } from '../components/audit/AuditTable';
import { ManagementPageLayout } from '../components/management/ManagementPageLayout';
import { useAuditData } from '../hooks/audit/useAuditData';
import { usePageTitle } from '../hooks/usePageTitle';
import { useRequireAuth } from '../hooks/useRequireAuth';
import {
  auditManagementStore,
  selectAudit,
} from '../stores/auditManagementStore';
import { hasSolanaEmailAddress } from '../utils/roleUtils';

export function AuditManagementPage() {
  const { authState, canRender } = useRequireAuth({
    requireRole: 'superadmin',
  });
  usePageTitle('Audit History | Publishing Portal');

  const {
    audits,
    isLoading,
    filters,
    sorting,
    pagination,
    actionOptions,
    entityTypeOptions,
    loadAudits,
    handleExport,
  } = useAuditData(authState);

  const selectedAuditId = useStore(
    auditManagementStore,
    (state) => state.ui.selectedAuditId,
  );

  const selectedAudit =
    audits.find((audit) => audit.id === selectedAuditId) || null;

  if (!canRender) {
    return null;
  }

  return (
    <ManagementPageLayout
      authState={authState}
      canAccess={(state) =>
        state.type === 'Authenticated' &&
        state.user.role === 'superadmin' &&
        hasSolanaEmailAddress(state.user.email)
      }
      className="flex-1 overflow-y-auto"
      contentClassName="max-w-7xl mx-auto px-8 py-6"
    >
      <div>
        <AuditFilterBar
          filters={filters}
          actionOptions={actionOptions}
          entityTypeOptions={entityTypeOptions}
          isLoading={isLoading}
          hasData={audits.length > 0}
          onLoadAudits={loadAudits}
          onExport={handleExport}
        />

        <AuditTable
          audits={audits}
          isLoading={isLoading}
          pagination={pagination}
          sorting={sorting}
          selectedAuditId={selectedAuditId}
        />
        <AuditDetailModal
          audit={selectedAudit}
          isOpen={!!selectedAuditId}
          onClose={() => selectAudit(null)}
        />
      </div>
    </ManagementPageLayout>
  );
}
